import { render } from "./ProductShowType.vue?vue&type=template&id=130cad16&scoped=true"
import script from "./ProductShowType.vue?vue&type=script&lang=js"
export * from "./ProductShowType.vue?vue&type=script&lang=js"

import "./ProductShowType.vue?vue&type=style&index=0&id=130cad16&scoped=true&lang=css"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130cad16"]])

export default __exports__